import { Outlet } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import AdminSidebar from '../components/sidebar/AdminSidebar'
import { sidebarOpenState } from '../store/DomainStore'

/**
 * Layout for the /admin area: a secondary rail of admin functions beside the
 * admin page content. The rail is sticky so it stays put while the page scrolls,
 * and it reads the shared sidebarOpenState so it collapses to a 68px icon rail in
 * lockstep with the main rail. Its h-16 header aligns with the main rail's header
 * rule, so the two dividers line up across the two columns.
 */
export default function AdminLayout() {
    const [sidebarOpen] = useRecoilState(sidebarOpenState)

    return (
        <div className="flex min-h-full flex-1">
            <aside
                className={`transition-[width] sticky top-0 flex h-screen flex-none flex-col border-r border-ink-200 bg-white ${
                    sidebarOpen ? 'w-60' : 'w-[68px]'
                }`}
            >
                <div
                    className={`flex h-16 flex-none items-center overflow-hidden border-b border-ink-100 ${
                        sidebarOpen ? 'px-5' : 'justify-center px-0'
                    }`}
                >
                    {/* Explicit Jost + !font-medium override the global Merriweather
                        h1-h4 rule (font-weight:400!important) in index.css — app
                        headings are Jost 500, matching PageMasthead. */}
                    {sidebarOpen && (
                        <h2 className="font-['Jost',system-ui,sans-serif] text-lg !font-medium text-ink-900">
                            Admin
                        </h2>
                    )}
                </div>
                <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden py-2">
                    <AdminSidebar />
                </div>
            </aside>
            <div className="min-w-0 flex-1">
                <Outlet />
            </div>
        </div>
    )
}
